import React, { PureComponent } from 'react';
//import PropTypes from 'prop-types';
import {
    Form, 
    Button, InputNumber,
    message,
} from 'antd';

class SukuranFontForm extends PureComponent {

    state = {

    }

    componentDidMount = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));
        this.setState(defConfig);
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    ukuran_font: values.font_size
                }, () => this.saveToLocal());
                message.success("Setting Tersimpan.");
            }
        });
    }

    saveToLocal = () => {
        let defConfig = JSON.parse(localStorage.getItem('configApp'));
        
        let newConfig = Object.assign({}, defConfig, {
            ukuranFont: this.state.ukuran_font
        });

        localStorage.setItem('configApp', JSON.stringify(newConfig));
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };
        return (
            <div>
                <Form onSubmit={this.handleSubmit} hideRequiredMark>
                    <Form.Item {...formItemLayout} label="Ukuran Font Slide">
                        {getFieldDecorator('font_size', {
                            rules: [{
                                required: true, message: 'Ukuran Font tidak boleh kosong!',
                            }],
                            initialValue: this.state.ukuranFont
                        })(
                            <InputNumber />
                        )}
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit">Terapkan</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const WrappedSukuranFontForm = Form.create({ name: 'SukuranFontForm' })(SukuranFontForm);

SukuranFontForm.propTypes = {

};

export default WrappedSukuranFontForm;